import { Component, h, ComponentInterface, Prop, Element, State } from '@stencil/core';
import { getQueryStringValue, guid } from 'utils';


@Component({
  tag: 'kdx-sitefinity-search',
  styleUrl: 'kdx-sitefinity-search.scss',
  shadow: false
})
export class StSitefinitySearch implements ComponentInterface {

  @State() guid: string = guid();

  @Element() root: HTMLElement;
  @Prop() resultsUrl: string;
  @Prop() indexCatalogue: string;
  @Prop() wordsMode: string;
  @Prop() label: string;
  @Prop() placeholder: string;
  @Prop() searchId: string = `site-search`;

  public searchValue: string;

  componentDidRender() {
    const searchTermQs = getQueryStringValue('searchQuery');

    if (searchTermQs && searchTermQs != '') {
      const searchInput: HTMLInputElement = this.root.querySelector('input.form-control');
      searchInput.value = searchTermQs;
    }
  }

  handleFocus() {
    this.root.querySelector('.kdx-site-search').classList.add('has-focus');
  }

  handleBlur() {
    this.root.querySelector('.kdx-site-search').classList.remove('has-focus');
  }

  handleClick(event: Event) {
    event.preventDefault();
    (event.target as HTMLElement).closest('.input-group').querySelector('.form-control').classList.toggle('show');

    Array.from((event.target as HTMLElement).closest('.input-group').querySelectorAll('.kdx-show-mobile-search .svg-icon')).forEach((icon) => {
      icon.classList.toggle('d-none');
    });
  }

  searchSubmit(e) {
    e.preventDefault();
    var term = this.searchValue;
    
    if (!(this.searchValue === undefined) && (term + '').trim() != '') {
      var qs = `?indexCatalogue=${this.indexCatalogue}&searchQuery=` + encodeURIComponent(term) + `&wordsMode=${this.wordsMode}`;
      window.location.href = this.resultsUrl + qs;
    }
    else {
      window.location.href = this.resultsUrl;
    }
  }

  setValue(e) {
    this.searchValue = e.target.value;
  }

  render() {
    return (
      <form class='kdx-site-search site-search input-group' onSubmit={(e) => { this.searchSubmit(e) }}>
        <label htmlFor={this.searchId} class="form-label visually-hidden">{this.label}</label>
        <input
          type="text"
          class="form-control"
          id={this.searchId}          
          placeholder={this.placeholder}
          onFocus={() => { this.handleFocus() }}
          onBlur={() => { this.handleBlur() }}
          onKeyUp={(e) => { this.setValue(e) }} />
        <button type="submit" class="input-group-text svg-icon" id="site-search-icon" aria-label="Submit Search">
          <kdx-icon icon="magnifying-glass"></kdx-icon>
        </button>
      </form>
    );
  }
}
